import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { resetAccessState } from '../../store/slices/access/routeAccessSlice';

const UnauthorizedPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleGoHome = () => {
    dispatch(resetAccessState());
    navigate('/dashboard/general', { replace: true });
  };

  return (
    <div className="relative flex h-screen w-full items-center justify-center overflow-hidden bg-gradient-to-br from-[#f9fafb] via-[#f3f4f6] to-[#e5e7eb] dark:from-[#0f172a] dark:via-[#1e293b] dark:to-[#0f172a] p-6">
      {/* 🌫️ Sutil animación de fondo */}
      <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_25%_25%,#DC3545_0%,transparent_60%),radial-gradient(circle_at_75%_75%,#2563eb_0%,transparent_60%)] animate-pulse" />

      <div className="relative w-full max-w-lg rounded-2xl border border-gray-200/30 dark:border-gray-700/30 bg-white/80 dark:bg-gray-900/60 backdrop-blur-lg p-10 text-center shadow-2xl transition-all duration-300">
        {/* 🔴 Ícono circular animado */}
        <div className="mb-6 flex items-center justify-center">
          <div className="relative flex h-24 w-24 items-center justify-center rounded-full bg-red-100 dark:bg-red-900/40 shadow-inner">
            <div className="absolute inset-0 rounded-full bg-[#DC3545]/20 animate-ping" />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-12 w-12 text-[#DC3545] z-10"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm-.75-10.25a.75.75 0 011.5 0v4.5a.75.75 0 01-1.5 0v-4.5zm.75 8.25a1 1 0 100-2 1 1 0 000 2z"
                clipRule="evenodd"
              />
            </svg>
          </div>
        </div>

        {/* 📄 Mensaje principal */}
        <h1 className="text-3xl font-extrabold text-gray-800 dark:text-white tracking-tight">
          Acceso Denegado
        </h1>
        <p className="mt-4 text-[15px] leading-relaxed text-gray-600 dark:text-gray-300">
          No tienes permisos suficientes para acceder a esta sección. <br />
          Si crees que se trata de un error, contacta al administrador del sistema.
        </p>

        {/* Línea decorativa */}
        <div className="mx-auto mb-8 mt-6 h-[2px] w-28 rounded-full bg-gradient-to-r from-[#DC3545] via-red-500 to-[#b52b38]" />

        {/* 🔘 Botón de regreso */}
        <button
          onClick={handleGoHome}
          className="inline-flex items-center justify-center gap-2 rounded-lg bg-gradient-to-r from-[#DC3545] to-[#b52b38] px-8 py-3 font-semibold text-white shadow-lg shadow-red-500/30 
          transition-all duration-200 hover:scale-[1.03] hover:shadow-red-600/40 active:scale-[0.98]"
        >
          <svg
            className="h-5 w-5"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.2"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
          </svg>
          <span>Volver al Inicio</span>
        </button>

        {/* Footer */}
        <p className="mt-8 text-xs text-gray-400 dark:text-gray-500 tracking-wide">
          © {new Date().getFullYear()} <span className="text-[#DC3545] font-semibold">Codenova POS</span> — Todos los derechos reservados
        </p>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
